import { Component } from 'react';
import { LayoutChangeEvent, View } from 'react-native';

import Currency from '../../../types/Currency';
import { Product } from '../../../types/TransactionDetail';
import ProductItem from './ProductItem';
import ProductListHeader from './ProductListHeader';
import { S } from './ProductListSection.style';

interface Props {
  data: Product[];
  isItemClickable: boolean;
  currency: Currency;
  onProductListLayout?: (e: LayoutChangeEvent) => void;
}

export default class ProductListSection extends Component<Props> {
  static defaultProps = {
    currency: {
      symbol: 'NT$',
      iso_code: 'TWD',
    },
  };

  static keyExtractor(item, index) {
    return `${item.title}-${index}`;
  }

  renderItem = (item: Product, index: number) => {
    const { currency } = this.props;
    const isFirst = index === 0;
    const key = `${item.id}-${item.size_text}-${item.color_text}`;

    return (
      <View key={key}>
        {!isFirst && ProductListSection.renderSeparator()}
        <ProductItem
          isClickable={this.props.isItemClickable}
          key={`product-${item.title}-${index}`}
          item={item}
          currency={currency}
        />
      </View>
    );
  };

  static renderSeparator() {
    return <S.Separator />;
  }

  render() {
    const { data, onProductListLayout } = this.props;

    return (
      <S.Container onLayout={onProductListLayout}>
        <ProductListHeader />
        {data.map(this.renderItem)}
      </S.Container>
    );
  }
}
